
import {Component, Vue} from "vue-property-decorator";
import {downloadQuoteLibrary, existedProduct} from "@/api/order-library";
import {ICustomerModel, IDefaultShippingOrderModel} from "@/api/types";
import Pagination from "@/components/Pagination/index.vue";
import {
  deleteUploadRecord,
  getEditableInfo,
  getModels,
  putEditableInfo,
  putExtendInfo,
  search,
  statistic,
} from "@/api/quote-library";
import {QuoteLibrary} from "@/model/QuoteLibrary";
import BaseTable from "@/components/BaseTable/index.vue";
import Index from "@/views/system-management/configuration/basic/index.vue";
import {searchCustomer} from "@/api/customer";
import History from "./components/History.vue";
import {getDraftPriceType, getSuppliersList} from "@/api/inquiry"
import {getExtend} from "@/api/product-number";
import LookRemark from "./components/lookRemark.vue"

@Component({
  name: "quotationProductLibrary",
  components: {
    Index,
    BaseTable,
    Pagination,
    History,
    LookRemark
  },
})
export default class extends Vue {
  public isShowMore = false;
  private showHistory = false;
  public remarkInfo = [] as any;
  private LSselectedItem = {} as any;
  public show_remark = false;
  private tableKey = 0;
  private total = 0;
  private listLoading = false;
  private quoteLibraryInfo: QuoteLibrary[] = [];
  private customers: ICustomerModel[] = [];
  private quoteNumber = 0;
  private quoteModelNumber = 0;
  private productNumberUnitNumber = 0;
  private listParam = {
    customer: "",
    productType: "",
    productNumber: "",
    time: "",
    pageNumber: 1,
    pageSize: 10,
  };

  private customerList = [
    { key: "0019f6cafcc54d45b4d97e4f72c979d4", value: "MID" },
    { key: "007701c23a35487286adf5d7f1bd1d2b", value: "OSAMA&SAMI" },
    { key: "01f7d7bdd68f458e9b7bf90405b1b12d", value: "Lintrex" },
    { key: "0294087894424850a8a350e76d0a2162", value: "BBB" },
    { key: "02ab6aac74474faca5ac8f958d4fa53a", value: "Nicol" },
    { key: "03713b43f3ec46c49ef827e89882a4f5", value: "Socomer" },
  ];

  private models = [
    { key: "OE", value: "OE" },
    { key: "HQ", value: "HQ" },
    { key: "REF", value: "REF" },
    { key: "TMP", value: "TMP" },
    { key: "其他型号", value: "其他型号" },
  ];

  base_info = [
    {
      label: "询价参照类型",
      prop: "inquiryReferenceNumberType",
      key: "inquiryReferenceNumberType",
    },
    {
      label: "询价参照号",
      prop: "inquiryReferenceNumber",
      key: "inquiryReferenceNumber",
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
    },
    {
      label: "productName",
      prop: "productName",
      key: "productName",
    },
    {
      label: "description1",
      prop: "description1",
      key: "description1",
      show_key: "show1",
    },
    {
      label: "产品属性1",
      prop: "productAttributes1",
      key: "productAttributes1",
      show_key: "show1",
    },
    {
      label: "description2",
      prop: "description2",
      key: "description2",
      show_key: "show1",
    },
    {
      label: "产品属性2",
      prop: "productAttributes2",
      key: "productAttributes2",
      show_key: "show1",
    },
    {
      label: "description3",
      prop: "description3",
      key: "description3",
      show_key: "show1",
    },
    {
      label: "产品属性3",
      prop: "productAttributes3",
      key: "productAttributes3",
      show_key: "show1",
    },
    {
      label: "description4",
      prop: "description4",
      key: "description4",
      show_key: "show1",
    },
    {
      label: "产品属性4",
      prop: "productAttributes4",
      key: "productAttributes4",
      show_key: "show1",
    },

    {
      label: "工艺",
      prop: "technicDesc",
      key: "technicDesc",
      show_key: "show1",
    },
    {
      label: "technic",
      prop: "technic",
      key: "technic",
      show_key: "show1",
    },
    {
      label: "产品信息",
      prop: "productInfoDesc",
      key: "productInfoDesc",
      show_key: "show1",
    },
    {
      label: "ProductInfo",
      prop: "productInfo",
      key: "productInfo",
      show_key: "show1",
    },
    {
      label: "车型/Car Application",
      prop: "carApplication",
      key: "carApplication",
      show_key: "show1",
    },

    {
      label: "报价供应商",
      prop: "supplier",
      key: "supplier",
    },
    {
      label: "采购单价",
      prop: "purchaseUnitPrice",
      key: "purchaseUnitPrice",
    },
    {
      label: "单价类型",
      prop: "unitPriceType",
      key: "unitPriceType",
    },
    {
      label: "销售报价",
      prop: "saleUnitPrice",
      key: "saleUnitPrice",
    },
    {
      label: "币种",
      prop: "currency",
      key: "currency",
    },
    {
      label: "报价利润率",
      prop: "profitRate",
      key: "profitRate",
    },
    {
      label: "报价利润额",
      prop: "profitAmount",
      key: "profitAmount",
    },
    {
      label: "报价时间",
      prop: "quoteTime",
      key: "quoteTime",
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        { name: "编辑", code: "", click: "handleEdit" },
        {
          name: "查看备注",
          code: "",
          click: "handlerSeeRemark",
        },
        { name: "查看历史报价单", code: "", click: "handleHistory" },
        { name: "删除", code: "", type: "delete", click: "handleDelete" },
      ],
      show: true,
      disabled: false,
      width: 300,
    },
  ];

  private editList = [
    {
      label: "productName",
      prop: "productName",
      key: "productName",
      type: "input",
      placeholder: "请输入华强品名",
      clearable: true,
    },
    {
      label: "description1",
      prop: "description1",
      key: "description1",
      type: "textarea",
      placeholder: "请输入description1",
      clearable: true,
    },
    {
      label: "productAttributes1",
      prop: "productAttributes1",
      key: "productAttributes1",
      type: "textarea",
      placeholder: "请输入productAttribute1",
      clearable: true,
    },
    {
      label: "description2",
      prop: "description2",
      key: "description2",
      type: "textarea",
      placeholder: "请输入description2",
      clearable: true,
    },
    {
      label: "productAttributes2",
      prop: "productAttributes2",
      key: "productAttributes2",
      type: "textarea",
      placeholder: "请输入productAttribute2",
      clearable: true,
    },
    {
      label: "description3",
      prop: "description3",
      key: "description3",
      type: "textarea",
      placeholder: "请输入description3",
      clearable: true,
    },
    {
      label: "productAttributes3",
      prop: "productAttributes3",
      key: "productAttributes3",
      type: "textarea",
      placeholder: "请输入productAttribute3",
      clearable: true,
    },
    {
      label: "description4",
      prop: "description4",
      key: "description4",
      type: "textarea",
      placeholder: "请输入description4",
      clearable: true,
    },
    {
      label: "productAttributes4",
      prop: "productAttributes4",
      key: "productAttributes4",
      type: "textarea",
      placeholder: "请输入productAttribute4",
      clearable: true,
    },
    {
      label: "工艺",
      prop: "technicDesc",
      key: "technicDesc",
      type: "textarea",
      placeholder: "请输入工艺",
      clearable: true,
    },
    {
      label: "technic",
      prop: "technic",
      key: "technic",
      type: "textarea",
      placeholder: "请输入technic",
      clearable: true,
    },
    {
      label: "产品信息",
      prop: "productInfoDesc",
      key: "productInfoDesc",
      type: "textarea",
      placeholder: "请输入productInfoDesc",
      clearable: true,
    },
    {
      label: "productInfo",
      prop: "productInfo",
      key: "productInfo",
      type: "textarea",
      placeholder: "请输入productInfo",
      clearable: true,
    },
    {
      label: "车型/Application",
      prop: "carApplication",
      key: "carApplication",
      type: "textarea",
      placeholder: "请输入carApplication",
      clearable: true,
    },
    {
      label: "供应商",
      prop: "supplierId",
      key: "supplierId",
      type: "select",
      value: "",
      placeholder: "请选择供应商",
      remote: true,
      remote_method: this.getSuppliersList,
      clearable: true,
      options: [],
      labelKey: "abbreviation",
      valueKey: "id",
    },
    {
      label: "利润率",
      prop: "profitRate",
      key: "profitRate",
      type: "input",
      placeholder: "请输入利润率",
      clearable: true,
    },
    {
      label: "采购单价",
      prop: "purchaseUnitPrice",
      key: "purchaseUnitPrice",
      type: "inputNumber",
      placeholder: "请输入采购单价",
      clearable: true,
    },
    {
      label: "采购折后单价",
      prop: "purchaseDiscountUnitPrice",
      key: "purchaseDiscountUnitPrice",
      type: "input",
      placeholder: "请输入采购折后单价",
      clearable: true,
    },
    {
      label: "销售单价",
      prop: "saleUnitPrice",
      key: "saleUnitPrice",
      type: "input",
      placeholder: "请输入销售单价",
      clearable: true,
    },
    {
      label: "销售折后单价",
      prop: "saleDiscountUnitPrice",
      key: "saleDiscountUnitPrice",
      type: "input",
      placeholder: "请输入采购单价",
      clearable: true,
    },
    {
      label: "单价类型",
      prop: "unitPriceType",
      key: "unitPriceType",
      type: "select",
      placeholder: "请选择单价类型",
      options: [],
      clearable: true,
      labelKey: "desc",
      valueKey: "name",
    },
    {
      label: "币种",
      prop: "currency",
      key: "currency",
      type: "select",
      placeholder: "请选择币种",
      clearable: true,
      maxlength: 100,
      options: [
        {
          name: "USD",
          id: "USD",
          value: "USD",
        },
        {
          name: "RMB",
          id: "RMB",
          value: "RMB",
        },
        {
          name: "ERUO",
          id: "ERUO",
          value: "ERUO",
        },
      ],
    },
    {
      label: "报价利润额",
      prop: "profitAmount",
      key: "profitAmount",
      type: "input",
      placeholder: "请输入报价利润额",
      clearable: true,
    },
    {
      label: "报价时间",
      prop: "quoteTime",
      key: "quoteTime",
      type: "datetime",
      placeholder: "请输入报价时间",
      clearable: true,
    },
  ];

  private editForm = {} as any;
  private showEdit = false;

  created() {
    this.getDraftPriceType();
    this.getSuppliersList();
  }

  activated() {
    this.getDraftPriceType();
    this.getSuppliersList();
  }

  private async getDraftPriceType() {
    const res: any = await getDraftPriceType();
    this.editList[23].options = res;
  }

  private async getSuppliersList(name = "") {
    const res: any = await this.getSuppliers(name);
    this.editList[14].options = res;
  }

  private async getSuppliers(name = "") {
    const res: any = await getSuppliersList({ abbreviation: name });
    return res;
  }

  private async handleEdit(row) {
    console.log(row);
    let params = {
      productNumberId: row.row.productNumberId,
    };
    const res: any = await getEditableInfo(params);
    this.editForm = res;
    this.editList[14].options = [
      { id: res.supplierId, abbreviation: res.supplier },
    ];
    this.showEdit = true;
  }

  private async handleDelete(row) {
    console.log(row);
    let params = {
      productNumberId: row.row.productNumberId,
    };
    await deleteUploadRecord(params);
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  private async handleFilter() {
    this.listLoading = true;
    await this.search();
    let params = {
      customerId: this.listParam.customer,
    };
    const res: any = await existedProduct(params);
    if (!res) {
      this.$notify.error({
        title: "提示",
        message: "存在产品有多个SN，请在报价库下载“异常文件”查看处理",
      });
    }
    this.listLoading = false;
  }

  private async search() {
    const params = {
      ...this.listParam,
      startDate: this.listParam ? this.listParam.time[0] : null,
      endDate: this.listParam.time[1] ? this.listParam.time[1] : null
    };
    const data: any = await search(params);
    this.quoteLibraryInfo = data.list;
    this.total = parseInt(data.total);
    const res: any = await statistic(params);
    this.quoteNumber = res.quoteNumber;
    this.quoteModelNumber = res.quoteModelNumber;
    this.productNumberUnitNumber = res.productNumberUnitNumber;
  }

  private async getList() {
    const params = {
      ...this.listParam,
      startDate: this.listParam ? this.listParam.time[0] : null,
      endDate: this.listParam.time[1] ? this.listParam.time[1] : null
    };
    const data: any = await search(params);
    this.quoteLibraryInfo = data.list;
    this.total = parseInt(data.total);
    const res: any = await statistic(params);
    this.quoteNumber = res.quoteNumber;
    this.quoteModelNumber = res.quoteModelNumber;
    this.productNumberUnitNumber = res.productNumberUnitNumber;
  }

  private showModel = false;

  async showModels() {
    this.showModel = !this.showModel;
    if (this.showModel === true) {
      let sum = 0;
      const quoteLibraryIds: string[] = this.quoteLibraryInfo.map(
        (value) => value.id
      );
      const data: any = await getModels({ quoteLibraryIds });
      this.quoteLibraryInfo = this.quoteLibraryInfo.map((value) => {
        const filter = data.filter((x) => x.quoteLibraryId === value.id);
        const index = this.base_info.findIndex(
          (obj) => obj.label === "询价参照号"
        );
        filter.forEach((x) => {
          const key = x.productTypeId;
          value[key] = x.productNumber;
          const columns = this.base_info.map((x) => x.label);
          if (!columns.includes(key)) {
            this.base_info.splice(index + sum + 1, 0, {
              label: key,
              prop: key,
              key: key,
            });
            sum++;
          }
        });
        return value;
      });
    } else {
      const startIndex = this.base_info.findIndex(
        (obj) => obj.label === "询价参照号"
      );
      const endIndex = this.base_info.findIndex(
        (obj) => obj.label === "华强品名"
      );
      this.base_info.splice(startIndex + 1, endIndex - startIndex - 1);
    }
  }

  async getDescription() {
    // const quoteLibraryIds: string[] = this.quoteLibraryInfo.map(value => value.id);
    // const data: any = await getDescription({quoteLibraryIds});
    // this.quoteLibraryInfo = this.quoteLibraryInfo.map(value => {
    //   const filter = data.filter(x => x.quoteLibraryId === value.id)[0];
    //   value.description1 = filter.description1;
    //   value.productAttributes1 = filter.productAttributes1;
    //   value.description2 = filter.description2;
    //   value.productAttributes2 = filter.productAttributes2;
    //   value.description3 = filter.description3;
    //   value.productAttributes3 = filter.productAttributes3;
    //   value.description4 = filter.productAttributes4;
    //   value.productAttributes4 = filter.productAttributes4;
    //   return value;
    // });
    // this.showDescription();
    this.isShowMore = !this.isShowMore;
  }

  private canShowDescription = false;

  private async confirmEdit() {
    this.editForm.supplier = this.editForm.supplierId;
    const res: any = putEditableInfo(this.editForm.infoId, this.editForm);
    this.$notify({
      title: "提示",
      message: "编辑保存成功",
      type: "success",
    });
    this.showEdit = false;
    this.getList();
  }

  private handleSuccess() {
    this.showHistory = false;
    (this.$refs.table as any).$refs.table.clearSelection();
    this.getList();
  }

  public async handleHistory(scope) {
    // console.log('点击的那个行',scope.row);
    if (scope.row.productNumberId) {
      this.LSselectedItem = scope.row;
      this.showHistory = true;
      // console.log('this.$refs.historyREF',this.$refs.historyREF);
      (this.$refs.historyREF as any).getListCreate(scope.row);
    } else {
      this.$notify({
        title: "提示",
        message: "该产品没有历史报价单",
        type: "warning",
      });
    }
  }

  private async downloadFile() {
    let params = {
      customerId: this.listParam.customer,
    };
    await downloadQuoteLibrary(params);
  }

  showDescription() {
    this.canShowDescription = !this.canShowDescription;
    const index = this.base_info.findIndex((obj) => obj.label === "华强品名");
    if (this.canShowDescription === true) {
      this.base_info.splice(index + 1, 0, {
        label: "description1",
        prop: "description1",
        key: "description1",
      });
      this.base_info.splice(index + 2, 0, {
        label: "产品属性1",
        prop: "productAttributes1",
        key: "productAttributes1",
      });
      this.base_info.splice(index + 3, 0, {
        label: "description2",
        prop: "description2",
        key: "description2",
      });
      this.base_info.splice(index + 4, 0, {
        label: "产品属性2",
        prop: "productAttributes2",
        key: "productAttributes2",
      });
      this.base_info.splice(index + 5, 0, {
        label: "description3",
        prop: "description3",
        key: "description3",
      });
      this.base_info.splice(index + 6, 0, {
        label: "产品属性3",
        prop: "productAttributes3",
        key: "productAttributes3",
      });
      this.base_info.splice(index + 7, 0, {
        label: "description4",
        prop: "description4",
        key: "description4",
      });
      this.base_info.splice(index + 8, 0, {
        label: "产品属性4",
        prop: "productAttributes4",
        key: "productAttributes4",
      });
    } else {
      this.base_info.splice(index + 1, 8);
    }
  }

  private isSearchingCustomers = false;

  private searchCustomers(a) {
    this.isSearchingCustomers = true;
    searchCustomer({ keyword: a })
      .then((res: any) => {
        this.customers = res;
        this.isSearchingCustomers = false;
      })
      .catch(() => {
        this.isSearchingCustomers = false;
      });
  }

  private removeRemark(index) {
    this.remarkInfo.splice(index, 1);
  }

  private addRemark() {
    this.remarkInfo.push({id: null,type: '',value: ''})
  }

  private async putExtendInfo() {
    let params = {
      productNumberId: this.productNumberId,
    };
    let data = {
      infos: this.remarkInfo,
    };
    await putExtendInfo(params, data);
    this.$notify({
      title: "成功",
      message: "提交成功",
      type: "success",
      duration: 2000,
    });
    this.show_remark = false;
    this.getList();
  }

  private selectedRows: IDefaultShippingOrderModel[] = [];

  private onSelectionChange(rows: IDefaultShippingOrderModel[]) {
    this.selectedRows = rows;
  }

  private productNumberId: any = "";

  private async handlerSeeRemark(row) {
    // 查看备注
    this.productNumberId = row.row.productNumberId
    this.remarkInfo = await getExtend(row.row.productNumberId)
    this.show_remark = true
  }
}
